/**
 * Русский — исходный язык макета. Остальные локали повторяют его структуру
 * ключ в ключ: добавили сюда — добавьте в uz и en, иначе fallback подставит
 * русский текст посреди узбекского экрана.
 *
 * Ключи сгруппированы по экранам, общие кнопки — в `common`.
 */
export default {
  common: {
    next: 'Далее',
    save: 'Сохранить',
    confirm: 'Подтвердить',
    yes: 'Да',
    cancel: 'Отмена',
    delete: 'Удалить',
    close: 'Закрыть',
    back: 'Назад',
    clear: 'Очистить',
    send: 'Отправить',
    apply: 'Применить',
    choose: 'Выбрать',
    done: 'Готово',
    expand: 'Развернуть',
    less: 'Меньше',
    more: 'Больше',
    map: 'Карта',
    total: 'Итого',
    calculation: 'Расчёт',
    sum: 'сум',
  },

  nav: {
    home: 'Главная',
    menu: 'Меню',
    cart: 'Корзина',
    orders: 'Заказы',
    profile: 'Профиль',
  },

  units: {
    ml: 'мл',
    g: 'г',
    kcal: 'ккал',
    protein: 'белки',
    fat: 'жиры',
    carbs: 'углеводы',
    per100: 'На 100 г',
    min: 'мин',
  },

  delivery: {
    delivery: 'Доставка',
    pickup: 'Самовывоз',
    takeaway: 'Заберу',
    free: 'Бесплатно',
  },

  toast: {
    success: 'Готово',
    error: 'Ошибка',
    warning: 'Внимание',
    info: 'Информация',
  },

  errors: {
    unknown: 'Неизвестная ошибка',
    timeout: 'Превышено время ожидания',
    offline: 'Нет связи с сервером',
    request: 'Ошибка запроса',
    captchaUnavailable: 'Капча недоступна',
    captchaFailed: 'reCAPTCHA не загрузилась',
    geoDenied: 'Доступ к геолокации запрещён — включите его в настройках или укажите точку вручную',
    geoFailed: 'Не удалось определить местоположение — укажите точку вручную',
    geoDeniedMap: 'Доступ к геолокации запрещён — включите его в настройках или укажите адрес на карте',
    geoSkipped: 'Без геолокации не страшно — укажите адрес на карте',
    pointNotFound: 'Не удалось найти точку по адресу — укажите её на карте',
    pointRequired: 'Укажите точку на карте',
  },

  onboarding: {
    languageTitle: 'Выберите язык',
    orderTypeTitle: 'Тип заказа',
    introTitle: 'Заказ за пару минут —\nпрямо в Telegram',
    geoTitle: 'Где вы находитесь?',
    geoText:
      'Определим город — покажем меню, цены и ближайший ресторан. Без этого никак:\nв разных городах они отличаются.',
    geoAction: 'Разрешить геолокацию',
    searchingTitle: 'Секундочку...',
    searchingText: 'Ищем вас на карте\nи ближайший ресторан',
    addressPlaceholder: 'Введите адрес',
  },

  auth: {
    signUp: 'Регистрация',
    signIn: 'Вход',
    phoneTitle: 'Ваш номер',
    phoneLabel: 'Номер телефона',
    telegramShare: 'Поделиться через Telegram',
    codeTitle: 'Введите код',
    codeHint: 'Мы отправили СМС с кодом подтверждения',
    codeResend: 'Отправить код ещё раз',
    codeSent: 'Сообщение отправлено на ваш номер телефона',
    signedIn: 'Вы авторизовались',
  },

  home: {
    bannerProductMissing: 'Этого товара сейчас нет в меню вашего филиала',
    addressLabel: 'Адрес доставки',
    addressEmpty: 'Укажите адрес',
    branchEmpty: 'Выберите филиал',
    searchPlaceholder: 'лаваш, донер, пепси...',
    hits: 'Хиты недели',
    novelties: 'Новинки',
  },

  menu: {
    notFound: 'Ничего не нашли',
    unavailable: 'Меню недоступно',
    tryAnotherQuery: 'Попробуйте изменить запрос',
    tryAnotherAddress: 'Попробуйте выбрать другой адрес или обновить страницу',
  },

  product: {
    add: 'Добавить',
    composition: 'Состав',
    extraModifiers: 'Дополнительные модификаторы',
    without: 'Без {name}',
    upsell: 'С этим часто покупают',
    addMore: 'Добавьте ещё {count}',
    removeSome: 'Уберите {count}',
    addToCart: 'Добавить в корзину',
    removeFromCart: 'Убрать из корзины',
    addToFavorites: 'В избранное',
    removeFromFavorites: 'Убрать из избранного',
  },

  cart: {
    offerNow: 'только сейчас',
    offerAdd: 'Добавить за {sum}',
    offerSkip: 'Спасибо, не нужно',
    title: 'Корзина',
    cutlery: 'Приборы',
    items: 'товар | товара | товаров',
    upsell: 'С этим часто покупают',
    empty: 'Корзина пуста',
    emptyText: 'Добавьте что-нибудь из меню',
    checkout: 'Оформить заказ',
    discount: 'Скидка',
  },

  checkout: {
    title: 'Оформление заказа',
    submit: 'Оформить',
    branch: 'Филиал',
    branchEmpty: 'Филиал не выбран',
    payment: 'Оплата',
    recipient: 'Получатель',
    recipientSelf: 'Себе',
    recipientOther: 'Другому',
    recipientTo: 'Кому доставить',
    nameRequired: 'Укажите имя',
    addressLabel: 'Адрес доставки',
    addressEmpty: 'Укажите адрес',
    entrance: 'Подъезд',
    floor: 'Этаж',
    flat: 'Кв/Офис',
    addressComment: 'Детали к адресу',
    firstName: 'Имя',
    lastName: 'Фамилия',
    phone: 'Номер телефона',
    products: 'Товары',
    promo: 'Промокод',
    promoDiscount: 'По промокоду',
    deliveryDiscount: 'Скидка на доставку',
    promoTitle: 'Ваши промокоды',
    promoPlaceholder: 'Вставьте промокод',
    promoInvalid: 'Промокод не подходит к этому заказу',
    pointsSpend: 'Списать баллы',
    pointsRate: '1 балл = 1 сум',
    pointsWithdraw: 'Спишем баллами',
    successTitle: 'Спасибо за заказ!',
    successNumber: 'Номер заказа:',
    successText: 'Звонка оператора ждать не нужно — мы сообщим, когда появятся обновления.',
    successPay: 'Оплатить заказ',
    successTrack: 'Отслеживать заказ',
    successTrackNumber: 'Заказ {number} • отслеживать',
    successHome: 'На главную',
  },

  orders: {
    free: 'Бесплатно',
    discount: 'Скидка',
    title: 'История заказов',
    tabActive: 'Активные',
    tabDone: 'Завершенные',
    emptyActive: 'Активных заказов нет',
    emptyDone: 'Здесь пока пусто',
    emptyText: 'Оформленные заказы появятся в этом списке',
    order: 'Заказ',
    repeat: 'Повторить',
    repeatMissing: 'Этих товаров сейчас нет в меню: {items}',
    track: 'Следить',
    yourOrder: 'Ваш заказ',
    notFound: 'Заказ не найден',
    support: 'Связаться с поддержкой',
    noName: 'Без имени',
    address: 'Адрес',
    canceled: 'Заказ отменён',
    cancel: 'Отменить заказ',
    refund: 'После получения вернём',
    courierChat: 'Написать курьеру',
    courierCall: 'Позвонить курьеру',
    route: 'Построить маршрут',
    rateTitle: 'Как прошёл ваш заказ?',
    rateText: 'Оцените заказ. Это поможет нам становиться лучше.',
    rateStar: 'Оценка {star}',
  },

  status: {
    accepted: 'Принят',
    acceptedText: 'Ресторан подтвердил заказ.',
    acceptedPickupText: 'Мы получили ваш заказ и уже передали\nего на кухню.',
    cooking: 'Готовится',
    cookingText: 'Повара уже готовят — осталось совсем немного.',
    cookingPickupText: 'Готовим ваш заказ. Осталось совсем немного.',
    onWay: 'Курьер в пути',
    onWayText: 'Курьер забрал заказ и едет к вам.',
    near: 'Курьер рядом',
    nearText: 'Я уже близко, буду через 5 минут!',
    delivered: 'Заказ доставлен',
    deliveredText: 'Приятного аппетита! Баллы уже начислены.',
    ready: 'Можно забирать',
    readyText: 'Заказ готов. Ждём вас в ресторане.',
  },

  profile: {
    title: 'Профиль',
    myData: 'Мои данные',
    language: 'Язык',
    support: 'Поддержка',
    feedback: 'Обратная связь',
    supportContacts: 'Чат-бот или 78 150 00 30',
    addName: 'Добавьте имя',
    noPhone: 'Номер не указан',
    edit: 'Редактировать профиль',
    addPhoto: 'Добавить фото',
    logout: 'Выйти из аккаунта',
    logoutConfirm: 'Выйти из аккаунта?',
    logoutAction: 'Выйти',
    photoTitle: 'Добавить фотографию',
    photoCamera: 'Камера',
    photoGallery: 'Галерея',
    photoFailed: 'Не удалось прочитать фотографию',
  },

  settings: {
    title: 'Настройки',
    personal: 'Личные данные',
    avatarTitle: 'Выберите аватар',
    phone: 'Номер телефона',
    firstName: 'Имя',
    lastName: 'Фамилия',
    email: 'Электронная почта',
    birthday: 'Дата рождения',
    birthdayEmpty: 'Выберите дату',
    genderTitle: 'Выберите пол',
    male: 'Мужской',
    female: 'Женский',
    saved: 'Данные сохранены',
  },

  points: {
    unit: 'баллов',
    heroTitle: 'Баллы\nуже ждут',
    balance: 'Ваш баланс',
    howTitle: 'Как работают баллы',
    ruleEarn: 'Возвращаем 5% от стоимости товаров баллами — сразу после получения заказа. В акциях кешбэк бывает выше.',
    ruleSpend:
      '1 балл = 1 сум. Оплачивайте баллами товары — хоть почти целиком, минимум 1 000 сум останется к оплате деньгами. На доставку баллы не действуют.',
    ruleExpiry: 'Баллы живут 3 месяца. Если начнут сгорать — предупредим в Telegram за 7 дней.',
    ruleProlong: 'Каждый новый заказ продлевает срок всех баллов ещё на 3 месяца. Заказывайте — и ничего не сгорит.',
    historyTitle: 'История',
    historyEmpty: 'Здесь появятся начисления и списания баллов',
  },

  promo: {
    title: 'Мои промокоды',
    available: 'Доступные промокоды',
    empty: 'Промокодов пока нет',
    emptyText: 'Следите за акциями — здесь появятся ваши промокоды',
    copy: 'Скопировать код',
    copied: 'Промокод скопирован',
    copyFailed: 'Не удалось скопировать код',
    until: 'до {date}',
    freeDelivery: 'Бесплатная доставка',
    gift: 'Подарок к заказу',
    orderDiscount: 'Скидка на заказ',
    percentOff: 'Скидка {percent}% на заказ',
    amountOff: 'Скидка {amount}',
    minOrder: 'от {amount}',
    itemsDiscount: 'Скидка на отдельные товары',
  },

  /* Автоматические акции: тексты из макета «Товары к корзине» */
  promotion: {
    deliveryLeft: 'до бесплатной доставки',
    deliveryDone: 'бесплатная доставка уже ваша',
    bonusLeft: 'до бесплатного бонуса',
    bonusDone: 'бонус уже у вас',
    allDone: 'Все бонусы получены!',
  },

  favorites: {
    title: 'Избранное',
    subtitle: 'Любимые позиции',
    empty: 'Пока здесь пусто',
    emptyText:
      'Добавляйте любимые товары в избранное, чтобы быстро находить их и заказывать снова',
    clearConfirm: 'Очистить избранное?',
  },

  cards: {
    title: 'Карты',
    mine: 'Мои карты',
    empty: 'Карт пока нет',
    emptyText: 'Привяжите карту, чтобы оплачивать заказы быстрее',
    add: 'Добавить карту',
    cash: 'Наличные',
  },

  notifications: {
    title: 'Уведомления',
    tabNews: 'Новости',
    tabPromotions: 'Акции',
    empty: 'Уведомлений нет',
    emptyText: 'Здесь появятся новости и акции Oqtepa Lavash',
  },

  chat: {
    title: 'Онлайн чат',
    placeholder: 'Сообщение',
    closed: 'Чат закрыт',
    closedHint: 'Обращение закрыто — писать сюда больше нельзя',
    call: 'Позвонить в поддержку',
    callConfirm: 'Позвонить в колл-центр?',
    attach: 'Прикрепить файл',
    empty: 'Обращений пока нет',
    request: 'Обращение в поддержку',
    uploading: 'Отправляем файл…',
    uploadFailed: 'Не удалось отправить файл',
    photo: 'Фото',
    noticeTitle: 'Новое сообщение от поддержки',
    noticeOpen: 'Открыть чат',
    unreadHint: 'Поддержка ответила — откройте чат',
  },

  address: {
    title: 'Мои адреса',
    listTitle: 'Адреса доставки',
    label: 'Адрес доставки',
    fallbackLabel: 'Адрес',
    new: 'Новый адрес',
    edit: 'Редактировать адрес',
    emptyAccent: 'Добавьте',
    emptyTitle: 'первый адрес',
    emptyText: 'Укажите удобный адрес, чтобы оформлять заказы всего за несколько касаний.',
    add: 'Добавить адрес',
    save: 'Сохранить адрес',
    remove: 'Удалить адрес',
    removeConfirm: 'Удалить адрес?',
    name: 'Название адреса',
    entrance: 'Подъезд',
    floor: 'Этаж',
    flat: 'Кв./Офис',
    entranceShort: 'подъезд',
    floorShort: 'этаж',
    flatShort: 'кв.',
    comment: 'Детали к адресу',
    detecting: 'Определяем адрес…',
    whereTo: 'Куда доставить?',
    findMe: 'Найти меня',
  },

  branch: {
    title: 'Выберите филиал',
    where: 'Где заберёте?',
    search: 'Поиск филиала',
    nearest: 'Показать ближайшие',
    notFound: 'Филиалы не найдены',
    workTime: 'Время работы:',
    workTimeShort: 'Время работы:',
    address: 'Адрес:',
    phone: 'Телефон:',
  },
}
